import React, { Component } from 'react';
import { useState } from 'react';
import ReactModal from 'react-modal';
import { getTranslatedText } from '../../../helpers/checkTranslations';
import { store } from '../../../redux/store';
import ExtraTaxe from './extraTaxe';
import ExtraTaxesModal from './extraTaxeModal';
const customStyles = {
    content: {
        top: '0',
        left: 'auto',
        right: '0',
        bottom: 'auto',
        width: '500px',
        backgroundColor: 'black',
    },
};

const ExtraTaxes = ({ extrataxes, providerForm, setProviderForm }) => {
    const [show, setShow] = useState(false);
    const showModal = () => {
        setShow(true);
    };
    const hideModal = () => {
        setShow(false);
    };
    return (
        <>
            <div className="fees-head flex-between">
                <h2>
                    {getTranslatedText('extraTaxes', store)}
                </h2>
                <ReactModal
                    isOpen={show}
                    style={customStyles}
                    contentLabel="Minimal Modal Example"
                    ariaHideApp={false}
                >
                    <ExtraTaxesModal setProviderForm={setProviderForm} providerForm={providerForm} hideModal={hideModal} />

                </ReactModal>
                <button
                    type="button"
                    className="default-btn"
                    data-attribute="modal-action"
                    onClick={showModal}
                    data-type="modal-add-tax">
                    {getTranslatedText('addTax', store)}
                </button>
            </div>
            {extrataxes && extrataxes.length > 0 && <div className="fees-content">
                <div className="fees-row-head">
                    <span className="col-3">
                        {getTranslatedText('name', store)}
                    </span>
                    <span className="col-3 text-center">
                        {getTranslatedText('percentage', store)}
                    </span>
                </div>
                {extrataxes.length > 0 ? extrataxes.map((extraTaxe, index) => <ExtraTaxe id={index} providerForm={providerForm} setProviderForm={setProviderForm} key={index} extraTaxe={extraTaxe} />) : []}
            </div>}
        </>

    );
};

export default ExtraTaxes;
